import { render } from "./BirthChartPreview.vue?vue&type=template&id=d844441e&scoped=true"
import script from "./BirthChartPreview.vue?vue&type=script&lang=js"
export * from "./BirthChartPreview.vue?vue&type=script&lang=js"

import "./BirthChartPreview.vue?vue&type=style&index=0&id=d844441e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d844441e"]])

export default __exports__